import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M36.328 15.078a1.876 1.876 0 0 1-2.656 0l-3.047-3.047V22.5a1.875 1.875 0 1 1-3.75 0V12.031l-3.047 3.047a1.89 1.89 0 0 1-2.656 0 1.876 1.876 0 0 1 0-2.656l6.25-6.25h.015l.125-.125.063-.047.078-.062.094-.047.062-.047.094-.032.078-.046.078-.032.094-.03h.094l.094-.032h.718l.094.031h.094l.078.031.094.032.078.03.094.048.062.047.094.046.062.063.078.047.125.11q0 .005.005.01a.02.02 0 0 0 .011.005l6.25 6.25a1.876 1.876 0 0 1 0 2.656M7.5 21.875h11.25a1.875 1.875 0 1 0 0-3.75H7.5a1.875 1.875 0 1 0 0 3.75m0-10h8.75a1.875 1.875 0 1 0 0-3.75H7.5a1.875 1.875 0 0 0 0 3.75m21.25 16.25H7.5a1.875 1.875 0 1 0 0 3.75h21.25a1.875 1.875 0 1 0 0-3.75"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }